<template>
    <div class="Team">
        <div class="row record-section-row">
            <div class="col">
                <h4>Wraparound Teams:</h4>
                <div>
                    <SingleMembershipEditorRequest :fields="[{name: 'WraparoundTeam.Name', title: 'TEAM', width: '33%'}, {name: 'StartDate', title: 'STARTED', callback: 'formatDate|MM/DD/YY', width: '33%'}, {name: 'EndDate', title: 'ENDED', callback: 'formatDate|MM/DD/YY|N/A', width: '33%'}]"
                                                   :field-data="ChildRecordData.WraparoundTeamMemberships"
                                                   :chart-id="ChildRecordData.Id"
                                                   :edit-mode="EditMode"
                                                   select-label="Team Name"
                                                   options-type="API"
                                                   options-method="Wraparound/Teams/ClientMemberships/GetAvailableTeamsForClient"
                                                   :options-method-record-id="ChildRecordData.Id"
                                                   add-record-method="Wraparound/Teams/ClientMemberships/AddClientToTeam"
                                                   add-record-record-property-name="TeamID"
                                                   :add-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                                   add-record-modal-title="Assign Initial Wrap Team"
                                                   transfer-record-method="Wraparound/Teams/ClientMemberships/TransferClientToTeam"
                                                   transfer-record-record-property-name="TeamID"
                                                   :transfer-record-additional-payload="{ClientSubProgramMembershipID: ChildRecordData.Id}"
                                                   transfer-record-modal-title="Transfer Client to New Team"
                                                   transfer-record-effective-date-property-name="EffectiveDate"
                                                   delete-record-method="Wraparound/Teams/ClientMemberships/DeleteClientFromTeam"
                                                   :delete-record-additional-payload="{Id: ChildRecordData.Id}"
                                                   delete-record-modal-title="Delete Current Wrap Team"
                                                   delete-record-modal-text="NOTICE: You are about to delete this child's current Wraparound Team.  If there was a previous Team assigned, it will be re-activated." 
                                                   edit-permission="Wraparound.ClientTeam.Edit.TeamAssignment" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Facilitator:</h4>
                <div>
                    <EmployeeCaseloadEditor :edit-mode="EditMode"
                                        team-role="Facilitator"
                                        :chart-id="ChildRecordData.Id"
                                        :table-data="EmployeeRoleSplit.Facilitators" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Behavioral Health Specialist:</h4>
                <div>
                    <EmployeeCaseloadEditor :edit-mode="EditMode"
                                        team-role="Behavioral Health Specialist"
                                        :chart-id="ChildRecordData.Id"
                                        :table-data="EmployeeRoleSplit.BHSs" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Parent Partner:</h4>
                <div>
                    <EmployeeCaseloadEditor :edit-mode="EditMode"
                                        team-role="Parent Partner"
                                        :chart-id="ChildRecordData.Id"
                                        :table-data="EmployeeRoleSplit.PPs" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Clinician:</h4>
                <div>
                    <EmployeeCaseloadEditor :edit-mode="EditMode"
                                        team-role="Clinician"
                                        :chart-id="ChildRecordData.Id"
                                        :table-data="EmployeeRoleSplit.Clinicians" />

                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Additional Support:</h4>
                <div>
                    <EmployeeCaseloadEditor :edit-mode="EditMode"
                                        team-role="Support"
                                        :chart-id="ChildRecordData.Id"
                                        :table-data="EmployeeRoleSplit.Supports" />

                </div>
            </div>
        </div>

        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="Wraparound.ClientTeam.Edit"/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import SingleMembershipEditorRequest from '../../../Core/ItemEditors/SingleMembershipEditorRequest.vue';
    import EmployeeCaseloadEditor from './EmployeeCaseloadEditor.vue';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            SingleMembershipEditorRequest,
            EmployeeCaseloadEditor,
            EditMode
        },
        mounted() {

        },
        computed: {
            EmployeeRoleSplit: function () {
                let output = {
                    Supervisors: this.ChildRecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Supervisor"),
                    Facilitators: this.ChildRecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Facilitator"),
                    BHSs: this.ChildRecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Behavioral Health Specialist"),
                    PPs: this.ChildRecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Parent Partner"),
                    Clinicians: this.ChildRecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Clinician"),
                    Supports: this.ChildRecordData.EmployeeCaseloads.filter(r => r.EmployeeRole == "Support")
                };
                return output;
            },
        }    
    }
</script>

<style scoped>
</style>